import type { ISeriesEventAttendee } from "@/types/series.types";
import { GetHvJson, HvHostMap } from "../helpers";

export default function LoadSeriesAttendee(eventUuid: string, language: string) {
	return GetHvJson<ISeriesEventAttendee[]>({
		path: `/e3-get-series/${eventUuid}/${language}`,
		service: HvHostMap.eventData
	});
}